import { useQuery } from '@tanstack/react-query';
import { useIsAuthenticated } from '@/common/stores/authStore';
import { getUnreadCount } from '../api/notifications.api';

export function useUnreadCount() {
  const isAuthenticated = useIsAuthenticated();
  return useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: getUnreadCount,
    enabled: isAuthenticated,
    refetchInterval: 30_000,
    staleTime: 15_000,
  });
}
